import { render, staticRenderFns } from "./TutorRequestCertificate.vue?vue&type=template&id=8163ce52&scoped=true&"
import script from "./TutorRequestCertificate.vue?vue&type=script&lang=js&"
export * from "./TutorRequestCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163ce52",
  null
  
)

export default component.exports